import React from "react";
import { SocialIcon } from "react-social-icons";

export const SocialIcons = () => (
    <>
        <SocialIcon
            className="SocialIcon"
            url="https://www.facebook.com/profile.php?id=100001516611711"
            fgColor="#fff"
            bgColor="#283043"
            style={{
                height: "30px",
                width: "30px",
            }}
        />
        <SocialIcon
            className="SocialIcon"
            url="https://www.instagram.com/franciscomrsilva/"
            fgColor="#fff"
            bgColor="#283043"
            style={{
                height: "30px",
                width: "30px",
            }}
        />
        <SocialIcon
            className="SocialIcon"
            url="https://www.linkedin.com/in/francisco-ribeiro-e-silva-144b511a9/"
            fgColor="#fff"
            bgColor="#283043"
            style={{
                height: "30px",
                width: "30px",
            }}
        />
    </>
);